import script from "./GroupForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupForm.vue?vue&type=script&lang=ts&setup=true"

import "./GroupForm.vue?vue&type=style&index=0&id=0c256daa&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c256daa"]])

export default __exports__